/**
 * Maps a `columns.tsx` column `id` to the backend sort column it represents.
 * Backend allow-list comes from orchestrator PR #1899; anything outside it 400s.
 */
export const SORT_FIELD_MAP: Record<string, string> = {
  date: 'started_at',
  status: 'status',
  success_rate: 'success_rate',
  simulations: 'total_count',
  fails: 'fail_count',
  duration: 'duration_seconds',
};

export const RUNS_FILTERS_STORAGE_KEY = 'runsFilters';

export const RUNS_DATE_STORAGE_KEY = 'runsDateFilter';
